import { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import httpService from "../config/httpCall";
import { get_Blog } from "../config/apiCall";
import { get_Catagory } from "../config/apiCall";
import { choose_Catagory } from "../config/apiCall";
import { get_catagory_Blog } from "../config/apiCall";
import { search_list } from "../config/apiCall";
import { Helmet } from "react-helmet";

import moment from "moment";
import NewHead from "./landing/NewHead";
import ServiceFooter from "./ServiceFooter";

function Home() {
  const [getBlog, setGetBlog] = useState([]);
  const [catagory, setCatagory] = useState([]);
  const [chooseCatagory, setChooseCatagory] = useState([]);
  const [getCatagaryBlog, setgetCatagaryBlog] = useState([]);
  const [search, setsearch] = useState(1);
  const [searchField, setSearchField] = useState("false");
  const [pageloader, setpageloader] = useState("false");
  const [count, setCount] = useState(5);

  useEffect(() => {
    get_Blog_Details(0);
    get_Catagory_Details(0);
    get_catagory(0);
  }, [0]);

  var urls = window.location.href;

  var urlsplit = urls.split("/").at(4);
  console.log(urlsplit, "urlsplit");
  console.log(urls, "urls");

  const get_catagory = async (view) => {
    setpageloader(true);
    if (urlsplit) {
      var obj = {
        url: urlsplit,
        view: view,
      };
      var data = {
        apiUrl: httpService.get_catagory_Blog,
        payload: obj,
      };
      var resp = await get_catagory_Blog(data);
      setpageloader(false);
      setgetCatagaryBlog(resp.Message.choosecatagory);
    } else {
    }
  };

  const viewmore = () => {
    if (urlsplit != undefined) {
      get_catagory("view");
    } else {
      get_Blog_Details("view");
    }
  };

  const get_Blog_Details = async (view) => {
    setpageloader(true);

    var obj = {
      data: view,
    };
    var data = {
      apiUrl: httpService.get_Blog,
      payload: obj,
    };
    var resp = await get_Blog(data);
    setGetBlog(resp.Message.get_Blog);
    setpageloader(false);
  };

  const get_Catagory_Details = async (view) => {
    var data = {
      apiUrl: httpService.get_Catagory,
    };
    var resp = await get_Catagory(data);
    console.log(resp.Message.get_Catagory, "-=-==data");
    setCatagory(resp.Message.get_Catagory);
  };

  const choose = async (e) => {
    var choosecatory = e.target.innerHTML;
    var obj = {
      choosecatory,
    };
    var data = {
      apiUrl: httpService.choose_Catagory,
      payload: obj,
    };

    var resp = await choose_Catagory(data);
    setgetCatagaryBlog(resp.Message.choosecatagory);
  };

  const searcharea = async (data) => {
    var obj = {
      search: data,
    };
    var data = {
      apiUrl: httpService.search_list,
      payload: obj,
    };
    var resp = await search_list(data);
    setSearchField(true);

    setCatagory(resp.Message.findblog);
  };
  return (
    <>
      {pageloader == true ? (
        <div className="nodata">
          <img
            className=" mx-auto d-block"
            src={require("../image/load2.gif")}
          ></img>
        </div>
      ) : (
        <div className="blog_header">
          <Helmet>
            <meta name="robots" content="index"></meta>
          </Helmet>
          <header className="newpage nft_new_page  p-0">
            {/* <Header /> */}
            <NewHead />
          </header>

          <main className="pading_dsds">
            <section className="blog_heading_section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="links_blog">
                      <div>
                        <h3>Blogs</h3>
                      </div>
                      <div>
                        <a href="/">Home</a>
                        <span>
                          <i className="bi bi-caret-right"></i>
                        </span>
                        <a href="/blog_details" className="current">
                          BLogs
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div className="container">
              <div className="row">
                <div className="col-lg-9">
                  <div className="row">
                    {urlsplit == undefined ? (
                      getBlog.length > 0 ? (
                        getBlog.map((item, i) => {
                          return (
                            <div className="col-lg-6">
                              <a
                                href={`/${item.slug}`}
                                target="_blank"
                                className="link_blog_section"
                              >
                                <div className="image_conainer">
                                  <img src={item.image} />
                                </div>
                                <div className="padding_section">
                                  <div className="blog_header">
                                    <h1>{item.metatitle}</h1>
                                    <div className="content_blog p-0">
                                      <div className="by_conte">
                                        <p>
                                          by<strong>{item.creator} </strong>
                                        </p>
                                        <span>
                                          {moment(item.createdAt).format(
                                            " Do MMMM  YYYY"
                                          )}
                                        </span>
                                      </div>
                                      {item.count}:view
                                    </div>
                                  </div>
                                  <div className="content_blog_text">
                                    <p>{item.metadescription}</p>
                                  </div>
                                </div>
                              </a>
                            </div>
                          );
                        })
                      ) : (
                        <div>
                          <img src={require("../image/nodata.png")}></img>
                        </div>
                      )
                    ) : getCatagaryBlog.length > 0 ? (
                      getCatagaryBlog.map((item, i) => {
                        return (
                          <div className="col-lg-6">
                            <a
                              href={`/${item.slug}`}
                              target="_blank"
                              className="link_blog_section"
                            >
                              <div className="image_conainer">
                                <img src={item.image} />
                              </div>
                              <div className="padding_section">
                                <div className="blog_header">
                                  <h1>{item.metatitle}</h1>
                                  <div className="content_blog p-0">
                                    <div className="by_conte">
                                      <p>
                                        by<strong>{item.creator} </strong>
                                      </p>
                                      <span>
                                        {moment(item.createdAt).format(
                                          "Do MMM YYYY"
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="content_blog_text">
                                  <p>{item.metadescription}</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        );
                      })
                    ) : (
                      <div className="nodata">
                        <img src={require("../image/nodata.png")}></img>
                      </div>
                    )}
                  </div>
                  {getCatagaryBlog && getBlog.length > 0 ? (
                    ""
                  ) : (
                    <div className="share_section button_virww">
                      <Button onClick={viewmore}>View More</Button>
                    </div>
                  )}
                </div>
                <div className="col-lg-3">
                  <div className="form_search">
                    <input
                      type="text"
                      placeholder="search"
                      onChange={(e) => searcharea(e.target.value)}
                    />

                    {/* <i className="bi bi-search" onClick={() => searcharea()}></i> */}
                  </div>
                  <div className="categorieded">
                    <h3>Categories</h3>
                    {searchField == false ? (
                      <>
                        {catagory.map((item, i) => {
                          return (
                            <ul>
                              <li>
                                <a
                                  onClick={choose}
                                  target="_blank"
                                  href={`/catogary/${item.categoryurl}`}
                                >
                                  {item.categoryname}
                                </a>
                              </li>
                            </ul>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        {catagory.map((item, i) => {
                          return (
                            <ul>
                              <li>
                                <a
                                  onClick={choose}
                                  target="_blank"
                                  href={`/catogary/${item.categoryurl}`}
                                >
                                  {item.categoryname}
                                </a>
                              </li>
                            </ul>
                          );
                        })}
                      </>
                    )}
                  </div>
                  {/* <div className="categorieded">
        <h3>Recent Posts</h3>
        <ul>
          <li>
            <a href="">
              <i className="bi bi-pencil-square"></i> All
            </a>
          </li>
          <li>
            <a href="">
              {" "}
              <i className="bi bi-pencil-square"></i>Clients
            </a>
          </li>

          <li>
            <a href="">
              {" "}
              <i className="bi bi-pencil-square"></i>Design
            </a>
          </li>

          <li>
            <a href="">
              {" "}
              <i className="bi bi-pencil-square"></i> News
            </a>
          </li>
        </ul>
      </div> */}
                </div>
              </div>
            </div>
          </main>

          {/* <main className="paddin_immner">
        <div className="page-title-area">
          <div className="container">
            <div className="page-title-content">
              <h1>Our Latest Articles</h1>
              <p>Temo is the easiest place to buy and sell cryptocurrency.</p>
            </div>
          </div>
          <div className="lines">
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </div>

        <div className="blog-details-area ptb-100">
          <div className="container">
            <div className="blog-details-header row align-items-center justify-content-center">
              <div className="col-lg-6 col-md-12">
                <div className="content">
                  <a href="/blog" className="category">
                    Filecoin
                  </a>
                  <h1>
                    How Filecoin is Up 50% in a Week &amp; Could Take More
                    Profits
                  </h1>
                  <p>
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout.
                  </p>
                  <div className="post-author-meta">
                    <div className="d-flex align-items-center">
                      <img
                        src="https://temo-vue.envytheme.com/img/user1.726e3948.jpg"
                        alt="image"
                      />
                      <div className="title">
                        <span className="name">
                          By{" "}
                          <a href="/blog" className="">
                            EnvyTheme
                          </a>
                        </span>
                        <span className="date">March 17, 2021</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="image">
                  <img
                    src="https://temo-vue.envytheme.com/img/blog1.dabd157f.jpg"
                    alt="image"
                  />
                </div>
              </div>
            </div>
            <div className="blog-details-desc">
                          <div className="article-content">
                            <ul className="social-links">
                              <li>
                                <a
                                  href="https://www.facebook.com/people/Beleaf-Technologies/100083681051307/"
                                  target="_blank"
                                  className="facebook"
                                >
                                  <i className="fab fa-facebook-f"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://twitter.com/BeleafTech"
                                  target="_blank"
                                  className="twitter"
                                >
                                  <i className="fab fa-twitter"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://www.linkedin.com/company/beleaf-technologies-blf/mycompany/"
                                  target="_blank"
                                  className="linkedin"
                                >
                                  <i className="fab fa-linkedin-in"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://www.instagram.com/beleaftechnologies/"
                                       target="_blank"
                                  className="instagram"
                                >
                                  <i className="fab fa-instagram"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://web.telegram.org/z/"
                                  target="_blank"
                                  className="telegram"
                                >
                                  <i className="fab fa-telegram"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="skype:live:.cid.62ff8496d3390349"
                                  target="_blank"
                                  className="skype"
                                >
                                  <i className="fab fa-skype"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://api.whatsapp.com/message/7LPZZGXW7ZHRO1?autoload=1&app_absent=0"
                                  target="_blank"
                                  className="whatsapp"
                                >
                                  <i className="fab fa-whatsapp"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="mailto:blftechorg@gmail.io"
                                  target="_blank"
                                  className="email"
                                >
                                  <i className="fa fa-email"></i>
                                </a>
                              </li>
                            </ul>
                <p>
                  Quuntur magni dolores eos qui ratione voluptatem sequi
                  nesciunt. Neque porro quia non jgstaa numquam eius modi
                  tempora incidunt ut labore et dolore magnam dolor sit amet,
                  consectetur adipisicing voluptatem sequi nesciunt.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur{" "}
                  <strong>adipisicing</strong> elit, sed do eiusmod tempor
                  incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                  veniam, quis nostrud exercitation ullamco laboris nisi ut
                  aliquip ex ea <a href="#">commodo</a> consequat. Duis aute
                  irure dolor in reprehenderit in sed quia non numquam eius modi
                  tempora incidunt ut labore et dolore magnam aliquam quaerat
                  voluptatem.
                </p>
                <h3>So, What Exactly is Positioning and Why Does It Matter?</h3>
                <p>
                  Quuntur magni dolores eos qui ratione voluptatem sequi
                  nesciunt. Neque porro quia non numquam eius modi tempora
                  incidunt ut labore et dolore magnam dolor sit amet,
                  consectetur adipisicing.
                </p>
                <ul>
                  <li>a console</li>
                  <li>Two Joy-Con controllers that are detachable</li>
                  <li>
                    A grip that enables you to combine them into a single{" "}
                    <a href="#">gamepad</a> for play on the
                  </li>
                  <li>
                    Two straps for turning the Joy-Cons into individual
                    controllers
                  </li>
                  <li>
                    A dock which you can use to connect your console to the{" "}
                    <strong>television</strong> for traditional gameplay
                  </li>
                </ul>
                <p>
                  Quuntur magni dolores eos qui ratione voluptatem sequi
                  nesciunt. Neque porro quia non jgstaa numquam eius modi
                  tempora incidunt ut labore et dolore magnam dolor sit amet,
                  consectetur adipisicing voluptatem sequi nesciunt.
                </p>
                <h3>How We Defined Our Positioning: a Step-by-Step Overview</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in sed quia non numquam eius modi
                  tempora incidunt ut labore et dolore magnam aliquam quaerat
                  voluptatem.
                </p>
                <blockquote className="wp-block-quote">
                  <p>
                    It is a long established fact that a reader will be
                    distracted by the readable when content of a page when
                    looking at its layout.
                  </p>
                  <cite>Tom Cruise</cite>
                </blockquote>
                <p>
                  Lorem Ipsum has been the industry’s standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen.
                </p>
                <ul className="wp-block-gallery columns-3">
                  <li className="blocks-gallery-item">
                    <figure>
                      <img
                        src="https://temo-vue.envytheme.com/img/blog4.68d031ec.jpg"
                        alt="image"
                      />
                    </figure>
                  </li>
                  <li className="blocks-gallery-item">
                    <figure>
                      <img
                        src="https://temo-vue.envytheme.com/img/blog4.68d031ec.jpg"
                        alt="image"
                      />
                    </figure>
                  </li>
                  <li className="blocks-gallery-item">
                    <figure>
                      <img
                        src="https://temo-vue.envytheme.com/img/blog4.68d031ec.jpg"
                        alt="image"
                      />
                    </figure>
                  </li>
                </ul>
                <p>
                  Lorem Ipsum has been the industry’s standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen.
                </p>
                <ul>
                  <li>Scientific skills for getting a better result</li>
                  <li>Communication skills to getting in touch</li>
                  <li>A career overview opportunity available</li>
                  <li>A good work environment for work</li>
                </ul>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud.
                </p>
                <div className="article-tags">
                  <a href="/blog" className="">
                    #Business
                  </a>
                  <a href="/blog" className="">
                    #Startup
                  </a>
                  <a href="/blog" className="">
                    #Agency
                  </a>
                </div>
                <div className="comment-respond">
                  <h3 className="comment-reply-title">Leave A Reply</h3>
                  <form className="comment-form">
                    <p className="comment-notes">
                      Your email address will not be published. Required fields
                      are marked <span className="required">*</span>
                    </p>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Eg: Sarah Taylor"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="hello@sarah.com"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="website"
                            className="form-control"
                            placeholder="Website"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="form-group">
                          <textarea
                            name="message"
                            className="form-control"
                            cols="30"
                            rows="5"
                            placeholder="Comment..."
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-5 col-sm-12">
                        <button type="submit" className="default-btn">
                          <i className="fas fa-paper-plane"></i> Post A Comment
                        </button>
                      </div>
                      <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="checkme"
                          />
                          <label className="form-check-label" htmlFor="checkme">
                            Save my name, email, and website in this browser for
                            the next time I comment.
                          </label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="blog-area pt-100 pb-70">
          <div className="container">
            <div className="section-title">
              <h2>You May Also Like</h2>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog-post">
                  <div className="post-image">
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active d-block"
                    >
                      <img
                        src="https://temo-vue.envytheme.com/img/blog1.dabd157f.jpg"
                        alt="image"
                      />
                    </a>
                    <div className="tag-list">
                      <a href="/blog" className="">
                        Filecoin
                      </a>
                    </div>
                  </div>
                  <div className="post-content">
                    <h3>
                      <a
                        aria-current="page"
                        href="/blog-details"
                        className="router-link-active active"
                      >
                        {" "}
                        How Filecoin is Up 50% in a Week &amp; Could Take More
                        Profits{" "}
                      </a>
                    </h3>
                    <p>
                      Borem ipsum dolor sit amet, adhuc iriure dissentias est
                      in, est ne diam graece tincidunt.
                    </p>
                    <div className="author d-flex align-items-center">
                      <img
                        src="https://temo-vue.envytheme.com/img/user1.726e3948.jpg"
                        alt="image"
                      />
                      <a href="/blog" className="">
                        Steven Smith
                      </a>
                    </div>
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active link-btn"
                    >
                      <i className="fas fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog-post">
                  <div className="post-image">
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active d-block"
                    >
                      <img
                        src="https://temo-vue.envytheme.com/img/blog1.dabd157f.jpg"
                        alt="image"
                      />
                    </a>
                    <div className="tag-list">
                      <a href="/blog" className="">
                        Education
                      </a>
                    </div>
                  </div>
                  <div className="post-content">
                    <h3>
                      <a
                        aria-current="page"
                        href="/blog-details"
                        className="router-link-active active"
                      >
                        {" "}
                        Coinbase Releases Investor Education Resources in 2021{" "}
                      </a>
                    </h3>
                    <p>
                      Borem ipsum dolor sit amet, adhuc iriure dissentias est
                      in, est ne diam graece tincidunt.
                    </p>
                    <div className="author d-flex align-items-center">
                      <img
                        src="https://temo-vue.envytheme.com/img/user1.726e3948.jpg"
                        alt="image"
                      />
                      <a href="/blog" className="">
                        Sarah Taylor
                      </a>
                    </div>
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active link-btn"
                    >
                      <i className="fas fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog-post">
                  <div className="post-image">
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active d-block"
                    >
                      <img
                        src="https://temo-vue.envytheme.com/img/blog1.dabd157f.jpg"
                        alt="image"
                      />
                    </a>
                    <div className="tag-list">
                      <a href="/blog" className="">
                        Bitcoin
                      </a>
                    </div>
                  </div>
                  <div className="post-content">
                    <h3>
                      <a
                        aria-current="page"
                        href="/blog-details"
                        className="router-link-active active"
                      >
                        {" "}
                        World’s Largest Bitcoin Conference Coming To Miami in
                        June{" "}
                      </a>
                    </h3>
                    <p>
                      Borem ipsum dolor sit amet, adhuc iriure dissentias est
                      in, est ne diam graece tincidunt.
                    </p>
                    <div className="author d-flex align-items-center">
                      <img
                        src="https://temo-vue.envytheme.com/img/user1.726e3948.jpg"
                        alt="image"
                      />
                      <a href="/blog" className="">
                        David Warner
                      </a>
                    </div>
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active link-btn"
                    >
                      <i className="fas fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main> */}

          {/* <Footer /> */}
          <ServiceFooter />
        </div>
      )}
    </>
  );
}

export default Home;
